module.exports = __webpack_public_path__ + "img/icon-3-f9828d6a.svg";